import {
    PRESUPUESTADOR_CALCULATE_REMAINDER,
} from '../constants';

export function calculateRemainder() {
    return (dispatch) => {
        dispatch({
            type: PRESUPUESTADOR_CALCULATE_REMAINDER
        })
    }
}